// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"c52dd059","461":"20682567","666":"6edfdb0c","787":"3c235e55"}[chunkId] + ".chunk.js";
};